var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0909 7C13.9995 7 15.5455 5.43375 15.5455 3.5C15.5455 1.56625 13.9995 0 12.0909 0C10.1823 0 8.63636 1.56625 8.63636 3.5C8.63636 5.43375 10.1823 7 12.0909 7ZM4.31818 5.25V2.625H2.59091V5.25H0V7H2.59091V9.625H4.31818V7H6.90909V5.25H4.31818ZM12.0909 8.75C9.785 8.75 5.18182 9.9225 5.18182 12.25V14H19V12.25C19 9.9225 14.3968 8.75 12.0909 8.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPerson);
export default __webpack_public_path__ + "static/media/plusPerson.f588b77f29782ce55f76ace78a680781.svg";
export { ForwardRef as ReactComponent };